<template>
  <div class="card-body px-0 pt-0 pb-3">
    <div class="table-responsive">
      <el-table
        v-loading="loading"
        border
        :data="docs"
        class="el-table-css"
        size="default"
        style="width: 100%"
        empty-text="Sənəd yoxdur"
      >
        <el-table-column prop="stage" label="Mərhələ" width="300"/>
        <el-table-column prop="source" label="Mənbə" width="300" />
        <el-table-column prop="documentName" label="Sənəd" width="300"/>
        <el-table-column label="Fayl">
          <template #default="scope">
            <div v-if="scope.row.fileName && scope.row.url">
              <div
                v-for="(file, idx) in splitFiles(scope.row.fileName)"
                :key="file + idx"
                class="file-row"
              >
                <span class="file-icon" :style="{ color: fileColor(file) }">
                  <i :class="fileIcon(file)"></i>
                </span>
                <a
                  class="file-link"
                  :href="splitFiles(scope.row.url)[idx]"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {{ file }}
                </a>
              </div>
            </div>
            <span v-else>—</span>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import { GetAllDocs } from "@/project/Source/subrogationdoc";

export default {
  props: {
    subrogationId: { type: [String, Number], required: true },
  },
  data() {
    return {
      docs: [],
      loading: false,
    };
  },
  watch: {
    subrogationId: {
      immediate: true,
      handler() {
        this.loadDocs();
      },
    },
  },
  methods: {
    async loadDocs() {
      this.loading = true;
      try {
        const { data } = await GetAllDocs(this.subrogationId);
        this.docs = data.data || [];
      } catch {
        this.docs = [];
        this.$message.error("Sənədlər yüklənmədi");
      } finally {
        this.loading = false;
      }
    },
    splitFiles(str) {
      return (str || "").split(",").map((s) => s.trim()).filter(Boolean);
    },
    fileIcon(filename) {
      const ext = filename.split(".").pop().toLowerCase();
      switch (ext) {
        case "pdf":
          return "fa-solid fa-file-pdf";
        case "doc":
        case "docx":
          return "fa-solid fa-file-word";
        case "xls":
        case "xlsx":
          return "fa-solid fa-file-excel";
        case "ppt":
        case "pptx":
          return "fa-solid fa-file-powerpoint";
        case "jpg":
        case "jpeg":
        case "png":
        case "gif":
          return "fa-solid fa-file-image";
        case "zip":
        case "rar":
          return "fa-solid fa-file-zipper";
        default:
          return "fa-solid fa-file-alt";
      }
    },
    fileColor(filename) {
      const ext = filename.split(".").pop().toLowerCase();
      switch (ext) {
        case "pdf":
          return "#e53935";
        case "doc":
        case "docx":
          return "#1976d2";
        case "xls":
        case "xlsx":
          return "#388e3c";
        case "ppt":
        case "pptx":
          return "#e67e22";
        case "jpg":
        case "jpeg":
        case "png":
        case "gif":
          return "#8e24aa";
        case "zip":
        case "rar":
          return "#616161";
        default:
          return "#757575";
      }
    },
  },
};
</script>

<style scoped>
.table-responsive {
  overflow-x: auto;
}
.file-link {
  color: #1976d2;
  text-decoration: underline;
  cursor: pointer;
  font-size: 15px;
  margin-left: 6px;
}
.file-link:hover {
  color: #0d47a1;
}
.file-row {
  display: flex;
  align-items: center;
  margin-bottom: 2px;
}
.file-icon {
  font-size: 18px;
  margin-right: 4px;
  margin-top: 1px;
}
</style>
